var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.595 6.15781L1.155 0.116667C1.0275 0.0437499 0.89625 0 0.74625 0C0.3375 0 0.00374994 0.328125 0.00374994 0.729167H0V13.2708H0.00374994C0.00374994 13.6719 0.3375 14 0.74625 14C0.9 14 1.0275 13.949 1.16625 13.876L11.595 7.84219C11.8425 7.64167 12 7.33906 12 7C12 6.66094 11.8425 6.36198 11.595 6.15781Z",
    fill: "#357221"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.e898f0a998fec06c7a4b4ad65579a962.svg";
export { ForwardRef as ReactComponent };